import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "q-gutter-sm" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_radio = _resolveComponent("q-radio")!
  const _component_radio_date_range_picker = _resolveComponent("radio-date-range-picker")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_q_radio, {
      "model-value": _ctx.valueString,
      val: "all",
      label: "All",
      "onUpdate:modelValue": _ctx.all
    }, null, 8, ["model-value", "onUpdate:modelValue"]),
    _createVNode(_component_q_radio, {
      "model-value": _ctx.valueString,
      val: "pre",
      label: "Pre Loss",
      "onUpdate:modelValue": _ctx.pre
    }, null, 8, ["model-value", "onUpdate:modelValue"]),
    _createVNode(_component_q_radio, {
      "model-value": _ctx.valueString,
      val: "post",
      label: "Post Loss",
      "onUpdate:modelValue": _ctx.post
    }, null, 8, ["model-value", "onUpdate:modelValue"]),
    _createElementVNode("div", null, [
      _createVNode(_component_radio_date_range_picker, {
        "model-value": _ctx.rangePickerValue,
        val: "custom",
        label: "Custom",
        "onUpdate:modelValue": _ctx.custom
      }, null, 8, ["model-value", "onUpdate:modelValue"])
    ])
  ]))
}